/**
 * Tiny pub/sub store. Avoid framework dep, use Custom Events on EventTarget.
 */
import type { Summary } from './types.ts';

export type Phase = 'gate' | 'loading' | 'ready' | 'error';

interface AppState {
  phase: Phase;
  summary: Summary | null;
  error: string | null;
}

class Store extends EventTarget {
  #state: AppState = { phase: 'gate', summary: null, error: null };

  get state(): Readonly<AppState> {
    return this.#state;
  }

  patch(partial: Partial<AppState>): void {
    this.#state = { ...this.#state, ...partial };
    this.dispatchEvent(new CustomEvent('change', { detail: this.#state }));
  }

  subscribe(cb: (s: Readonly<AppState>) => void): () => void {
    const handler = (e: Event) => cb((e as CustomEvent).detail);
    this.addEventListener('change', handler);
    cb(this.#state);
    return () => this.removeEventListener('change', handler);
  }
}

export const store = new Store();
